// extracted by mini-css-extract-plugin
export var RecruitFooter = "RecruitFooter-module--RecruitFooter--d2DA0";
export var RecruitFooter__pankuzu = "RecruitFooter-module--RecruitFooter__pankuzu--3Zv56";
export var RecruitFooter__logo = "RecruitFooter-module--RecruitFooter__logo--i1hxQ";
export var RecruitFooter__btm = "RecruitFooter-module--RecruitFooter__btm--2afZ3";